import { createAction } from '@reduxjs/toolkit'

export const getIntegrationObjectDefinitionKey = 'api/integration/getIntegrationObjectDefinition'
export const getIntegrationObjectDefinitionRequested = createAction(`${getIntegrationObjectDefinitionKey}/requested`)
export const getIntegrationObjectDefinitionSuccess = createAction(`${getIntegrationObjectDefinitionKey}/success`)
export const getIntegrationObjectDefinitionFailed = createAction(`${getIntegrationObjectDefinitionKey}/failed`)
